// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.completeTable {
  height: calc(100vh - 125px);
  overflow: auto;
  margin: 0px 20px 0px 30px;
}

.iconsText {
  background-color: transparent;
  color: #666;
  display: flex;
  box-shadow: none;
  height: 20px;
  border: none;
  padding: 0px;
}

.iconsText:hover {
  background-color: transparent;
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./components/ProjectList/ProjectList.css"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,cAAA;EACA,yBAAA;AACF;;AACA;EACE,6BAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;AAEF;;AAAA;EACE,6BAAA;EACA,gBAAA;AAGF","sourcesContent":[".completeTable {\n  height: calc(100vh - 125px);\n  overflow: auto;\n  margin: 0px 20px 0px 30px;\n}\n.iconsText {\n  background-color: transparent;\n  color: #666;\n  display: flex;\n  box-shadow: none;\n  height: 20px;\n  border: none;\n  padding: 0px;\n}\n.iconsText:hover {\n  background-color: transparent;\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
